// src/pages/ApplicationChampionshipSeason/shared/steps/Step2Stages/KnockoutStageList.tsx
import { FunctionComponent } from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { Reorder } from 'framer-motion';
import { useFieldArray, useFormContext } from 'react-hook-form';

import { SeasonFormData } from '../../schemas';
import { KnockoutStageItem } from './KnockoutStageItem';
import { AddStageButton } from './AddStageButton';

type KnockoutStageListProps = {
  /** Texto do botão de adicionar (varia entre KNOCKOUT e HYBRID). */
  addLabel: string;
  /** Quando true, esconde drag-handle, lixeira e o botão "Adicionar fase". */
  isReadOnly?: boolean;
};

/** Lista ordenável (drag) de fases de mata-mata. Edita o campo `knockout_stages`. */
export const KnockoutStageList: FunctionComponent<KnockoutStageListProps> = ({
  addLabel,
  isReadOnly = false,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SeasonFormData>();
  const { fields, append, remove, move } = useFieldArray({
    control,
    name: 'knockout_stages',
  });

  const ids = fields.map(field => field.id);

  const handleReorder = (nextIds: string[]) => {
    if (isReadOnly) return;
    for (let to = 0; to < nextIds.length; to += 1) {
      if (nextIds[to] !== ids[to]) {
        const from = ids.indexOf(nextIds[to]);
        if (from !== -1) move(from, to);
        return;
      }
    }
  };

  const listError =
    (errors.knockout_stages as { message?: string; root?: { message?: string } } | undefined)
      ?.message ??
    (errors.knockout_stages as { root?: { message?: string } } | undefined)?.root?.message;

  return (
    <Flex direction="column" gap={3}>
      <Reorder.Group
        as="div"
        axis="y"
        values={ids}
        onReorder={handleReorder}
        style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}
      >
        {fields.map((field, index) => (
          <KnockoutStageItem
            key={field.id}
            id={field.id}
            index={index}
            onRemove={() => remove(index)}
            isReadOnly={isReadOnly}
          />
        ))}
      </Reorder.Group>

      {isReadOnly ? null : (
        <AddStageButton label={addLabel} onClick={() => append({ name: '' })} />
      )}

      {listError ? (
        <Text fontSize="13px" color="red.500">
          {listError}
        </Text>
      ) : null}
    </Flex>
  );
};
